export default __webpack_public_path__ + "d37708f16b1ff4892ce40dea5836050f.woff2";